export const GET_CSV_IMPORT_TABLE_SCHEMAS = 'GET_CSV_IMPORT_TABLE_SCHEMAS'
export const GET_CSV_IMPORT_SCHEMA = 'GET_CSV_IMPORT_SCHEMA'
export const UPLOAD_CSV_IMPORT_FILE = 'UPLOAD_CSV_IMPORT_FILE'
export const CONFIRM_CSV_IMPORT = 'CONFIRM_CSV_IMPORT'
export const BULK_CSV_IMPORT = 'BULK_CSV_IMPORT'
export const GET_SCHOOL_SYSTEMS = 'GET_SCHOOL_SYSTEMS'
export const GET_SCHOOL_SYSTEMS_DETAILS = 'GET_SCHOOL_SYSTEMS_DETAILS'
export const CREATE_CSV_IMPORT_VENUES = 'CREATE_CSV_IMPORT_VENUES'
export const DOWNLOAD_CSV_IMPORT_TEMPLATE = 'DOWNLOAD_CSV_IMPORT_TEMPLATE'
